import { useEffect } from 'react';
import { prop } from 'ramda';
import { dispatcher } from 'dispatcher';
import { useDispatch } from 'react-redux';

import { get } from 'js/utils/fetch.util';
import { fromArrayToObject } from 'js/app/utils/common.util';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import * as actions from 'js/components/system/App/store/actions';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';
import * as helpers from 'js/components/system/App/hooks/useGetGamesConfiguration/helpers';
import {
    useFilterFeedBlacklist
} from '@interlayer/js/components/system/App/hooks/useGetGamesConfiguration/helpers';

/* core, added gamesFeedsObject and isTurnOn */
export const useGetGamesConfiguration = (isTurnOn) => {
    const getCMSResourceURL = useGetCMSResourceURL();
    const dispatch = useDispatch();
    const lang = useUserSelector(prop('lang'));
    const requestStamp = useAppSelector(prop('requestStamp'));
    const filterFeedBlacklist = useFilterFeedBlacklist();

    useEffect(() => {
        if (!lang || !isTurnOn) {
            return;
        }

        const requestURL = getCMSResourceURL(`/initialResources/games/${lang}`, { t: requestStamp });

        get(requestURL)
            .then(({ gamesConfiguration, gamesFeeds, ...other }) => {
                const filteredGames = helpers.filterGames(gamesConfiguration);
                const activeGames = filterFeedBlacklist(filteredGames, gamesFeeds);

                const response = {
                    ...other,
                    gamesFeeds,
                    gamesConfiguration,
                    gamesFeedsObject: fromArrayToObject({
                        data: gamesFeeds,
                        key: 'name',
                        filter: (item) => item.active && item.categories.length,
                        parse: ({ categories, ...gameFeedsData }) => {
                            return {
                                ...gameFeedsData,
                                categories: categories.map(category => ({
                                    ...category,
                                    name: category.name.trim(),
                                    gameCodes: category.gameCodes.filter(gameCode => activeGames[gameCode])
                                }))
                            };
                        }
                    }),
                    games: activeGames
                };

                dispatcher.dispatch('games:data', response);
                dispatch(actions.updateGamesData(response));
            });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, lang, requestStamp, getCMSResourceURL, isTurnOn]);
};
